'use client'
import React from 'react'
import Moment from 'react-moment'
import moment from 'moment'
import { LANGUAGE } from '@/data/constants'

import 'moment/locale/sv';
import 'moment/locale/en-gb';

export default function MomentClient(props) {
  moment().locale(LANGUAGE)
  const { date, className } = props
  return (
    <Moment className={className} locale={LANGUAGE} date={date} title={date} fromNow />
  )
}
